// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2fw_d","fullScreen":"style_fullScreen__2mia6","hidden":"style_hidden__3PGS6"};